import { Component, Input } from '@angular/core';
import { AutoGenIconPipe } from 'pipes-lib';

@Component({
  selector: 'app-filetype-icon',
  templateUrl: './filetype-icon.component.html',
  styleUrl: './filetype-icon.component.scss',
  imports: [AutoGenIconPipe],
})
export class FileTypeIconComponent {
  @Input() value?: string;
  AUTO_GEN_ICON = '<=>';

  constructor() {}
}
